// Ensure default filter is applied on page load
// (function ensureDefaultAvailabilityFilter() {
//   const param = 'filter.v.availability=1';
//   const search = window.location.search;
//   if (!search.includes(param)) {
//     const url = new URL(window.location.href);
//     if (url.search) {
//       url.search += (url.search.endsWith('&') ? '' : '&') + param;
//     } else {
//       url.search = '?' + param;
//     }
//     window.location.replace(url.toString());
//   }
// })();

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    if (searchParams && searchParams.includes('discount_percent')) {
      FacetFiltersForm.renderPageWithDiscountFilter(searchParams, event, updateURLHash);
      return;
    }
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static async renderPageWithDiscountFilter(searchParams, event, updateURLHash) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const perPage = parseInt(grid.dataset.productsPerPage || '16', 10);
    const params = new URLSearchParams(searchParams);
    const selected = params.getAll('discount_percent');
    if (!selected.length) {
      params.delete('discount_percent');
      FacetFiltersForm.renderPage(params.toString(), event, updateURLHash);
      return;
    }
    const key = FacetFiltersForm._discountCacheKey();
    const cache = FacetFiltersForm.__discountCache;
    if (cache && cache.key === key && cache.completed) {
      FacetFiltersForm._applyDiscountFilterFromCache(grid, selected, perPage, searchParams, updateURLHash);
      return;
    }
    const loading = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    const countEl = document.getElementById('ProductCount');
    const countElD = document.getElementById('ProductCountDesktop');
    loading.forEach((s) => s.classList.remove('hidden'));
    grid.closest('.collection').classList.add('loading');
    if (countEl) countEl.classList.add('loading');
    if (countElD) countElD.classList.add('loading');
    const base = window.location.pathname + '?section_id=' + (grid.dataset.sectionId || grid.dataset.id);
    const totalPages = parseInt(grid.dataset.totalPages || '1', 10);
    const urls = [];
    for (let p = 1; p <= totalPages; p++) {
      const q = new URLSearchParams(searchParams);
      if (p > 1) q.set('page', String(p));
      urls.push(base + '&' + q);
    }
    try {
      const htmls = await Promise.all(urls.map((u) => fetch(u).then((r) => r.text())));
      const allItems = [];
      htmls.forEach((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const c = doc.getElementById('ProductGridContainer');
        if (c) c.querySelectorAll('#product-grid .grid__item[data-discount-percent]').forEach((li) => { const p = li.getAttribute('data-discount-percent'); if (p) allItems.push({ html: li.outerHTML, pct: p }); });
      });
      FacetFiltersForm.__discountCache = { key: key, allItems: allItems, completed: true };
      FacetFiltersForm._applyDiscountFilterFromCache(grid, selected, perPage, searchParams, updateURLHash);
    } catch (e) {
      grid.closest('.collection').classList.remove('loading');
      loading.forEach((s) => s.classList.add('hidden'));
      if (countEl) countEl.classList.remove('loading');
      if (countElD) countElD.classList.remove('loading');
    }
  }

  static _discountCacheKey() {
    const p = new URLSearchParams(window.location.search);
    p.delete('page');
    p.delete('discount_percent');
    return window.location.pathname + '?' + p;
  }

  static _applyDiscountFilterFromCache(grid, selected, perPage, searchParams, updateURLHash) {
    const cache = FacetFiltersForm.__discountCache;
    const items = (cache && cache.allItems) ? cache.allItems.filter((i) => selected.includes(i.pct)).map((i) => i.html) : [];
    const loading = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loading.forEach((s) => s.classList.add('hidden'));
    grid.closest('.collection').classList.remove('loading');
    const page = Math.min(Math.max(1, parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10)), Math.max(1, Math.ceil(items.length / perPage)));
    const totalP = Math.max(1, Math.ceil(items.length / perPage));
    const start = (page - 1) * perPage;
    grid.innerHTML = items.slice(start, start + perPage).join('');
    FacetFiltersForm._renderDiscountPagination(totalP, page, searchParams);
    const txt = items.length === 0 ? 'No products' : items.length + ' ' + (items.length === 1 ? 'product' : 'products');
    [document.getElementById('ProductCount'), document.getElementById('ProductCountDesktop')].forEach((el) => { if (el) { el.innerHTML = txt; el.classList.remove('loading'); } });
    FacetFiltersForm._appendDiscountPills(selected);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid.innerHTML);
    if (window.initializeVariantItemEvents) window.initializeVariantItemEvents(grid);
    if (window.initialiseCoureSwatches) window.initialiseCoureSwatches();
    if (window.productsliderfun) window.productsliderfun();
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static _renderDiscountPagination(totalPages, currentPage, searchParams) {
    const wrap = document.querySelector('.pagination-wrapper');
    if (!wrap || totalPages <= 1) { if (wrap) wrap.innerHTML = ''; return; }
    const p = new URLSearchParams(searchParams);
    const path = window.location.pathname;
    const link = (pg) => { p.set('page', String(pg)); return '<a href="' + path + '?' + p + '" class="pagination__item link motion-reduce js-discount-pagination' + (pg < currentPage ? ' pagination__item--next pagination__item-arrow' : ' pagination__item--prev pagination__item-arrow') + '">...</a>'; };
    let h = '<div class="pagination-wrapper"><nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';
    if (currentPage > 1) h += '<li>' + link(currentPage - 1) + '</li>';
    for (let i = 1; i <= totalPages; i++) h += '<li>' + (i === currentPage ? '<a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page">' + i + '</a>' : (p.set('page', String(i)), '<a href="' + path + '?' + p + '" class="pagination__item link js-discount-pagination">' + i + '</a>')) + '</li>';
    if (currentPage < totalPages) h += '<li>' + link(currentPage + 1) + '</li>';
    wrap.outerHTML = h + '</ul></nav></div>';
    document.querySelectorAll('.js-discount-pagination').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); FacetFiltersForm.renderPageWithDiscountFilter(new URL(a.href).searchParams.toString(), null, true); }));
  }

  static _appendDiscountPills(selected) {
    if (!selected || !selected.length) return;
    const p = new URLSearchParams(window.location.search);
    p.delete('discount_percent');
    const base = window.location.pathname + (p.toString() ? '?' + p : '');
    const containers = document.querySelectorAll('.active-facets-desktop .active-facets-vertical-filter, .active-facets-mobile');
    selected.forEach((pct) => {
      const other = selected.filter((x) => x !== pct);
      const href = other.length ? base + (base.includes('?') ? '&' : '?') + other.map((x) => 'discount_percent=' + x).join('&') : base;
      const pill = '<facet-remove><a href="' + href + '" class="active-facets__button active-facets__button--light"><span class="active-facets__button-inner button button--tertiary">Discount: -' + pct + '%</span></a></facet-remove>';
      containers.forEach((c) => { const w = c.querySelector('.active-facets__button-wrapper'); if (w) { const t = document.createElement('div'); t.innerHTML = pill; w.parentElement.insertBefore(t.firstElementChild, w); } });
    });
  }

  static _renderDiscountCheckboxes(percents, selected, listD, listM, sectionIdAttr) {
    const cb = (pct, id, mob) => {
      const idStr = 'Filter-discount_percent-' + id + '-' + pct;
      const cls =
        (mob ? 'facets__label mobile-facets__label facet-checkbox' : 'facets__label facet-checkbox') +
        (selected.includes(String(pct)) ? ' active' : '');
      const checkedAttr = selected.includes(String(pct)) ? ' checked' : '';
      const inputAttr = mob ? ' class="mobile-facets__checkbox"' : '';
      const highlight = mob ? '<span class="mobile-facets__highlight"></span>' : '';

      return (
        '<li class="list-menu__item facets__item' +
        (mob ? ' mobile-facets__item' : '') +
        '"><label for="' +
        idStr +
        '" class="' +
        cls +
        '"><input type="checkbox"' +
        inputAttr +
        ' name="discount_percent" value="' +
        pct +
        '" id="' +
        idStr +
        '"' +
        checkedAttr +
        '>' +
        highlight +
        '<svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect></svg>' +
        '<svg aria-hidden="true" class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
        '<span class="facet-checkbox__text" aria-hidden="true"><span class="facet-checkbox__text-label">-' +
        pct +
        '%</span></span></label></li>'
      );
    };
    const empty = '<li class="list-menu__item facets__item"><span class="caption">No discounts</span></li>';
    if (listD) listD.innerHTML = percents.length ? percents.map((p) => cb(p, 'desktop', false)).join('') : empty;
    if (listM) listM.innerHTML = percents.length ? percents.map((p) => cb(p, 'mobile', true)).join('') : empty.replace('facets__item', 'mobile-facets__item');
    if (sectionIdAttr && selected.length) { const e = document.getElementById('DiscountFacetCount-' + sectionIdAttr); if (e) { e.textContent = ' (' + selected.length + ')'; e.classList.remove('hidden'); } }
  }

  static fetchAndPopulateDiscountFacet() {
    const grid = document.getElementById('product-grid');
    const listD = document.querySelector('[id^="DiscountFacetList-"]');
    const listM = document.querySelector('[id^="DiscountFacetListMobile-"]');
    if (!grid || (!listD && !listM)) return Promise.resolve();
    const sectionIdAttr = (listD && listD.getAttribute('data-section-id')) || (listM && listM.getAttribute('data-section-id'));
    const selected = new URLSearchParams(window.location.search).getAll('discount_percent');
    const percents = [];
    const currentItems = [];
    grid.querySelectorAll('.grid__item[data-discount-percent]').forEach((li) => { const p = li.getAttribute('data-discount-percent'); if (p) { if (percents.indexOf(p) === -1) percents.push(p); currentItems.push({ html: li.outerHTML, pct: p }); } });
    percents.sort((a, b) => Number(a) - Number(b));
    FacetFiltersForm._renderDiscountCheckboxes(percents, selected, listD, listM, sectionIdAttr);
    const totalPages = parseInt(grid.dataset.totalPages || '1', 10);
    const key = FacetFiltersForm._discountCacheKey();
    if (totalPages <= 1) { FacetFiltersForm.__discountCache = { key: key, allItems: currentItems, completed: true }; return Promise.resolve(); }
    const curPage = Math.max(1, parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10));
    const base = window.location.pathname + '?section_id=' + (grid.dataset.sectionId || grid.dataset.id);
    const q = new URLSearchParams(window.location.search);
    q.delete('page');
    q.delete('discount_percent');
    const qs = q.toString();
    const urls = [];
    for (let p = 1; p <= totalPages; p++) { if (p === curPage) continue; urls.push(p === 1 ? base + '&' + qs : base + '&' + qs + '&page=' + p); }
    const allItems = currentItems.slice();
    const set = new Set(percents);
    return Promise.all(urls.map((u) => fetch(u).then((r) => r.text()))).then((htmls) => {
      htmls.forEach((html) => { const doc = new DOMParser().parseFromString(html, 'text/html'); doc.querySelectorAll('#product-grid .grid__item[data-discount-percent]').forEach((li) => { const p = li.getAttribute('data-discount-percent'); if (p) { allItems.push({ html: li.outerHTML, pct: p }); set.add(p); } }); });
      FacetFiltersForm._renderDiscountCheckboxes(Array.from(set).map(Number).filter((n) => !isNaN(n)).sort((a, b) => a - b), selected, listD, listM, sectionIdAttr);
      FacetFiltersForm.__discountCache = { key: key, allItems: allItems, completed: true };
    }).catch(() => {});
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (elementToRender.id && (elementToRender.id.indexOf('Discount') !== -1)) return;
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('product-grid') || !document.querySelector('.js-filter-discount')) return;
  var qs = window.location.search;
  FacetFiltersForm.fetchAndPopulateDiscountFacet().then(function () {
    if (qs.indexOf('discount_percent=') !== -1) FacetFiltersForm.renderPageWithDiscountFilter(qs.slice(1), null, false);
  });
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
